import {ReactComponent as ClientsIcon} from "../assets/fonts/feather/users.svg";
import {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Tag} from "primereact/tag";
import {Badge} from "primereact/badge";
import {useDispatch, useSelector} from "react-redux";
import {toggleAside} from "../actions/main";

export default function SideBarItem(props) {

    const [isParent, setIsParent] = useState(props.isParent)
    const [counter, setCounter] = useState(props.counter)
    const [isToggle, setToggle] = useState(false);
    let nav = useNavigate();
    const loc = useLocation()
    const {pathname} = loc;
    const splitLocation = pathname.split("/");
    const dispatch = useDispatch()

    const isMobile = useSelector(function (state){
        return state.isMobile
    })


    function clickHandler(e) {
        e.preventDefault()
        if (isParent) {
            setToggle(!isToggle);
        }
        if (props.link) {
            nav(props.link);
            if(isMobile) {
                dispatch(toggleAside('close_icon'))
            }
        }

    }

    useEffect(() => {
        setIsParent(props.isParent)
        setCounter(props.counter)
    }, [props])

    return (
        <li className="sidebar-list">
            <a className={"sidebar-link sidebar-title " + (splitLocation[1] === props.link || pathname == props.link ? 'active' : '')}
               href="#" onClick={clickHandler}>
                {props.icon}
                <span>{props.title}</span>

                <span className={'m-l-5'}>
                    {counter ? <Badge className={''} value={'+' + counter}/> : ''}
                </span>
                {isParent &&
                    <div className="according-menu">
                        <i className={"fa fa-angle-" + (isToggle ? 'down' : 'right')}>

                        </i>
                    </div>
                }

            </a>


            {isParent && isToggle &&
                <ul className={'sidebar-submenu'}>
                    {props.children}
                </ul>
            }
        </li>
    )
}